import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";
import SupportSelfService from "@/components/support/SupportSelfService";

export default function Support() {
  const nav = useNavigate();
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => { api.get("/support/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-surface max-w-[520px] mx-auto pb-10">
      <div className="sticky top-0 z-40 bg-white border-b border-border px-3 py-3 flex items-center gap-2">
        <button onClick={() => nav(-1)} className="w-9 h-9 flex items-center justify-center tap"><ArrowLeft size={22} /></button>
        <h1 className="font-display font-bold text-lg">Help & Support</h1>
      </div>
      <div className="px-4 py-4 space-y-3">
        <SupportSelfService />
        <div className="bg-white rounded-2xl border border-border p-4">
          <h3 className="font-bold text-ink mb-2">Frequently asked</h3>
          {faqs.map((f, i) => (
            <div key={i} className="border-b border-border last:border-0">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between py-3 text-left"><span className="text-sm font-semibold text-ink pr-2">{f.q}</span><ChevronDown size={17} className={`shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} /></button>
              {open === i && <p className="text-sm text-ink-600 pb-3">{f.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
